import { BODiagnosticNovo } from '../BODiagnosticNovo.model';

export class BOTranspDiagnosticNovo {
    diagnosticNovos:BODiagnosticNovo[]=[];
    patientId:number;
    clinicHistoryId:number;
}
